/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./table-header.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./table-header.component";
var styles_TableHeaderComponent = [i0.styles];
var RenderType_TableHeaderComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_TableHeaderComponent, data: {} });
export { RenderType_TableHeaderComponent as RenderType_TableHeaderComponent };
export function View_TableHeaderComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "button", [["type", "submit"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["submit"])), i1.ɵncd(null, 0)], null, null); }
export function View_TableHeaderComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "form", [["ccTableHeader", ""]], null, null, null, View_TableHeaderComponent_0, RenderType_TableHeaderComponent)), i1.ɵdid(1, 114688, null, 0, i2.TableHeaderComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var TableHeaderComponentNgFactory = i1.ɵccf("form[ccTableHeader]", i2.TableHeaderComponent, View_TableHeaderComponent_Host_0, {}, {}, ["*"]);
export { TableHeaderComponentNgFactory as TableHeaderComponentNgFactory };
